import { Analysis } from '../dashboard-config.model';

/** Facts about an analysis that hold for every metric and granularity. */
export interface AnalysisProfile {
  id: Analysis;
  /** Analysis segment of dataset names (`ds__…__ts__…__vm`); empty where the name has none. */
  datasetToken: string;
}

export const ANALYSIS_PROFILES: Record<Analysis, AnalysisProfile> = {
  [Analysis.Dossier]: { id: Analysis.Dossier, datasetToken: '' },
  [Analysis.TimeSeries]: { id: Analysis.TimeSeries, datasetToken: 'ts' },
  [Analysis.Ranking]: { id: Analysis.Ranking, datasetToken: 'rk' },
  [Analysis.Comparison]: { id: Analysis.Comparison, datasetToken: 'ca' },
  [Analysis.Forecast]: { id: Analysis.Forecast, datasetToken: 'fcst' },
  [Analysis.Gender]: { id: Analysis.Gender, datasetToken: '' },
  [Analysis.Index]: { id: Analysis.Index, datasetToken: 'idx' },
};
